import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  typescript,
  html,
  css,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  figma,
  docker,
  nagarro,
  iit,
  coding,
  threejs,
  myapp,
  rapidresume,
  rapidrender,
  snake,
  snappypost,
  stone,
  todo,
  urlzip,
  weather,
  chirag,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Frontend Developer",
    icon: web,
  },
  {
    title: "React Specialist",
    icon: mobile,
  },
  {
    title: "Backend Developer",
    icon: backend,
  },
  {
    title: "AI Enthusiast",
    icon: creator,
  },
];

const technologies = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "TypeScript",
    icon: typescript,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "Three JS",
    icon: threejs,
  },
  {
    name: "git",
    icon: git,
  },
  {
    name: "figma",
    icon: figma,
  },
  {
    name: "docker",
    icon: docker,
  },
];

const experiences = [
  {
    title: "Custom Software Senior Analyst",
    company_name: "Accenture",
    icon: nagarro,
    iconBg: "#383E56",
    date: "Sep 2025 - Present",
    location: "Gurugram, India",
    points: [
      "Working with 2 developers to drive Adobe Target frontend design and implementation for 4 website journeys.",
      "Creating Functional and Technical Design Documents to define scope, architecture, and workflows in the design phase.",
      "Developing scalable, reusable, and responsive frontend components ensuring accessibility and high-quality user experience.",
      "Supporting Adobe Target integration with other Adobe products while mentoring team members and ensuring delivery quality.",
    ],
  },
  {
    title: "Software Engineer",
    company_name: "GlobalLogic",
    icon: coding,
    iconBg: "#E6DEDD",
    date: "Jan 2024 - May 2025",
    location: "Gurugram, India",
    points: [
      "Optimized web applications using ReactJS, JavaScript, HTML5, CSS, and Adobe Target, enhancing personalized experiences.",
      "Increased engagement by 10% through A/B testing and targeted content delivery via Adobe Target.",
      "Engineered reusable UI components, reducing frontend development time by 30% across multiple projects.",
      "Initiated run-time offer rendering, resulting in a 15% higher conversion rate for client.",
      "Enhanced customer retention by 10% using Adobe Target recommendations tailored to user browsing behavior.",
    ],
  },
  {
    title: "Associate Software Engineer",
    company_name: "Nagarro",
    icon: nagarro,
    iconBg: "#383E56",
    date: "Aug 2021 - Nov 2023",
    location: "Gurugram, India",
    points: [
      "Worked on development of 4+ client projects using ReactJS, TypeScript, and Redux, delivering high-performance UIs.",
      "Implemented 11+ responsive web interfaces with Material Design and Bootstrap, improving cross-device user experience.",
      "Innovated by creating 6+ custom React components from scratch and improving the functionality of existing components.",
      "Engineered templates for diverse components, enabling their streamlined use across multiple projects for the same client through ReactJS and TypeScript, increasing efficiency across projects by 20%.",
      "Resolved UI-related issues by effectively employing Jira and Figma, ensuring a smooth user experience.",
    ],
  },
  {
    title: "Summer Trainee",
    company_name: "ICT Academy, IIT Kanpur",
    icon: iit,
    iconBg: "#E6DEDD",
    date: "Jun 2020 - Jul 2020",
    location: "Kanpur, India",
    points: [
      "Completed classroom training in AI & ML fundamentals with hands-on problem-solving at IIT Kanpur.",
      "Sparked ongoing interest in LLMs, GPT, and prompt engineering for practical AI-driven workflows.",
    ],
  },
];

const education = [
  {
    degree: "Master of Computer Applications",
    institution: "M.M.M.U.T.",
    period: "2018 - 2021",
  },
  {
    degree: "Bachelor of Computer Applications",
    institution: "V.B.S. Purvanchal University",
    period: "2014 - 2017",
  },
];

const certificates = [
  {
    name: "React: Getting Started",
    issuer: "Pluralsight",
  },
  {
    name: "Introduction to Generative AI - Art of the Possible",
    issuer: "Amazon Web Services (AWS)",
  },
  {
    name: "OCI 2025 AI Foundations Associate",
    issuer: "Oracle",
  },
  {
    name: "Academy Accreditation - Generative AI Fundamentals",
    issuer: "Databricks",
  },
];

const testimonials = [
  {
    testimonial:
      "Sagar has a good hold of frontend development and is also proficient at building things from scratch with a long-term view in mind.",
    name: "Chirag Udeshi",
    designation: "SDE",
    company: "Credit Suisse",
    image: chirag,
  },
];

const projects = [
  {
    name: "RapidResume",
    description:
      "Built a resume builder that enables users to generate professional, customizable resumes with export-ready elegant themes.",
    tags: [
      {
        name: "reactjs",
        color: "blue-text-gradient",
      },
      {
        name: "auth 2.0",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: rapidresume,
    source_code_link: "https://rapidresume.vercel.app/",
  },
  {
    name: "RapidRender",
    description:
      "Developed a web tool to dynamically generate UI assets like gradients, palettes, SVGs & patterns for fast design prototyping.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "svgs",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: rapidrender,
    source_code_link: "https://devsagarkhatri.github.io/rapidrender",
  },
  {
    name: "UrlZip",
    description:
      "Experience hassle-free sharing of URLs with URLZip! It makes it easy to shorten URLs in seconds, helping you cater to your clients and increase your brand outreach online.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "restapi",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: urlzip,
    source_code_link: "https://urlzip.vercel.app/",
  },
  {
    name: "Snappy Post",
    description:
      "Web-based platform that allows users to create engaging twitter like posts to be shared on other social platforms to increase your audience.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "forms",
        color: "green-text-gradient",
      },
      {
        name: "bootstrap",
        color: "pink-text-gradient",
      },
    ],
    image: snappypost,
    source_code_link: "https://snappypost.vercel.app/",
  },
  {
    name: "Weather App",
    description:
      "Experience the convenience of getting real-time weather updates with just a click using our user-friendly application. Never let the weather ruin your day again !",
    tags: [
      {
        name: "reactjs",
        color: "blue-text-gradient",
      },
      {
        name: "api",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: weather,
    source_code_link: "https://devsagarkhatri.github.io/weather/",
  },
  {
    name: "To-Do List",
    description:
      "A web-app that effortlessly sorts your tasks by status. Our elegant design ensures you prioritize with ease, with the ability to mark tasks as important for extra focus.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "forms",
        color: "green-text-gradient",
      },
      {
        name: "bootstrap",
        color: "pink-text-gradient",
      },
    ],
    image: todo,
    source_code_link: "https://github.com/",
  },
  {
    name: "Classic Snake",
    description:
      "Experience the nostalgic thrill of the classic snake game! Play now and indulge in the fun of maneuvering the snake to catch the food, all while avoiding the walls and your own tail.",
    tags: [
      {
        name: "reactjs",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: snake,
    source_code_link: "https://devsagarkhatri.github.io/snake/",
  },
  {
    name: "Stone-Paper-Scissors",
    description:
      "Challenge your friends to a game of Stone-Paper-Scissors with our sleek and modern ReactJS application! So why not put your skills to test and see who comes out on top?",
    tags: [
      {
        name: "reactjs",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: stone,
    source_code_link: "https://devsagarkhatri.github.io/stone-paper-scissors/",
  },
  {
    name: "My Apps",
    description:
      "A collection of Apps like Merchandise Counter, Movies List, Todo App and Chart app made while learning the web development languages like ReactJs and Javascript.",
    tags: [
      {
        name: "reactjs",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: myapp,
    source_code_link: "https://devsagarkhatri.github.io/my-app/",
  },
];

export {
  services,
  technologies,
  experiences,
  education,
  certificates,
  testimonials,
  projects,
};